<template>
    <div class="bg-white p-4 relative shadow-md w-6/6 md:w-5/6  lg:w-4/6 xl:w-4/6 mx-auto">
        <button onclick="document.title='recu_commande_cavilam'; window.print();"><i class="fa fa-print" aria-hidden="true"></i></button>
        <h1 class="text-3xl my-4 font-bold text-center">{{ __(commande.site.constante) }}</h1>
        <div>
            <div class="flex">
                <div class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('Civilite') }}</p>
                    <p class="text-center">{{ __(commande.client.civilite) }}</p>
                </div>
                <div class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('Prenom') + ' / ' + __('Nom') }}</p>
                    <p class="text-center">{{ __(commande.client.prenom) + ' / ' + __(commande.client.nom) }}</p>
                </div>
            </div>
            <div class="flex">
                <div class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('date_naissance') }}</p>
                    <p class="text-center">{{ reformatDate(commande.client.date_naissance) }}</p>
                </div>
                <div class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('Nationalite') }}</p>
                    <p class="text-center">{{ __(commande.client.nationalite) }}</p>
                </div>
            </div>
            <div class="flex">
                <div class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('adresse_email') }}</p>
                    <p class="text-center">{{ commande.client.email }}</p>
                </div>
                <div class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('adresse') }}</p>
                    <p class="text-center">{{ commande.client.adresse }}, {{ commande.client.ville }} ({{ commande.client.code_postal }}), {{ commande.client.pays }}</p>
                </div>
            </div>
            <div class="flex">
                <div class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('Profession') }}</p>
                    <p class="text-center">{{ commande.client.profession }}</p>
                </div>
                <div class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('Facturation') }}</p>
                    <p v-if="commande.client.adresse_facturation" class="text-center">{{ commande.client.adresse_facturation }}, {{ commande.client.ville_facturation }} ({{ commande.client.code_postal_facturation }}), {{ commande.client.pays_facturation }}</p>
                    <p v-else class="text-center">{{ commande.client.adresse }}, {{ commande.client.ville }} ({{ commande.client.code_postal }}), {{ commande.client.pays }}</p>
                </div>
            </div>
            <div class="flex">
                <div v-if="commande.client.langue_maternelle" class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('langue_maternelle') }}</p>
                    <p class="text-center">{{ commande.client.langue_maternelle }}</p>
                </div>
                <div v-if="commande.client.ville_naissance" class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('ville_naissance') }}</p>
                    <p class="text-center">{{ commande.client.ville_naissance + ', ' +  commande.client.pays_naissance }}</p>
                </div>
            </div>
            <div class="flex">
                <div class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('Newsletter') }}</p>
                    <p class="text-center"><span v-if="commande.client.newsletter">{{ __('accepte') }}</span><span v-else>{{ __('refuse') }}</span></p>
                </div>
                <div class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('date_de_transaction') }}</p>
                    <p class="text-center">{{ reformatDateTime(commande.date_validation) }}</p>
                </div>
            </div>
            <div class="flex">
                <div class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('sous_total') }}</p>
                    <p class="text-center">{{ commande.montant_sous_total }} €</p>
                </div>
                <div class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('frais_inscription') }}</p>
                    <p class="text-center">{{ commande.montant_inscription }} €</p>
                </div>
            </div>
            <div class="flex">
                <div class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('mode_de_paiement') }}</p>
                    <p class="text-center">{{ commande.type_carte }}</p>
                </div>
                <div class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('montant_total') }}</p>
                    <p class="text-center">{{ commande.montant_preleve }} €</p>
                </div>
            </div>
            <div class="flex">
                <div v-if="commande.contient_examen" class="w-1/2 m-2">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('motif_dinscription') }}</p>
                    <p class="text-center">{{ formatMotifInscription(commande.client?.motif_dinscription) }}</p>
                </div>
                <div :class="commande.contient_examen ? 'w-1/2 m-2' : 'w-full m-2'">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('code_promo') }}</p>
                    <p class="text-center" v-if="commande.reduction">
                        {{ commande.reduction.code }} (-{{ commande.montant_reduction }}€)
                    </p>
                </div>
            </div>

            <div class="flex">
                <div class="w-full m-2" v-if="commande.options">
                    <p class="font-bold text-cavilam-primary text-center">{{ __('options') }}</p>
                    <p class="text-center">
                        <ul>
                            <li v-for="(option, index) in commande.options" :key="index" v-html="translateOption(option)"></li>
                        </ul>
                    </p>
                </div>
            </div>
            <div class="my-5">
                <p id="transaction-id" class="text-pink-300 block text-center font-medium leading-6 px-6 py-3 bg-pink-700">
                    {{ commande.transaction_num }}
                </p>
            </div>
            <div class="w-full">
                <h3 class="font-bold text-gray-600 text-left px-4">{{ __('cours_examens_choisis') }}</h3>
                <div class="mt-5 w-full">
                    <div v-for="item in commande.achats" class="w-full border-t-2 border-gray-100 font-medium text-gray-600 p-4 w-full flex">
                        <div class="w-3/6 m-2">
                            <template v-if="item.produit.categorie.par_combinaison">
                                <p class="font-bold text-cavilam-primary" v-html="__(item.produit.categorie.slug)"></p>
                                <div v-for="(programme, key) in item.programmes">
                                    <p class="font-bold" v-if="key < 1">{{ __('module_matin') }}</p>
                                    <p class="font-bold" v-else>{{ __('module_apres_midi') }}</p>
                                    <p class="text-sm">{{ __(programme.produit.slug) }} <span v-if="item.niveau"> - {{ __(item.niveau.constante) }}</span></p>
                                    <p v-if="key >= 1" class="ml-2 text-gray-700 text-sm">
                                        <template v-if="programme.produit.par_semaines">
                                            <span  v-html="__('programmation_semaine', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                        </template>
                                        <template v-else-if="!programme.date_fin">
                                            <span v-html="__('programmation_date', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                        </template>
                                        <template v-else>
                                            <span v-html="__('programmation_periode', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}, {key: 'FIN_JOUR', value: (new Date(programme.date_fin)).getDate()}, {key: 'FIN_MOIS', value: (new Date(programme.date_fin)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'FIN_ANNEE', value: (new Date(programme.date_fin)).getFullYear()}])"></span>
                                        </template>
                                    </p>
                                </div>
                            </template>
                            <template v-else-if="item.produit.enfants && item.produit.enfants.length">
                                <p class="font-bold text-cavilam-primary">
                                    <span v-html="__(item.produit.categorie.slug) + ' <i class=\'fa fa-chevron-right\'></i> ' + __(item.produit.slug)"></span>
                                    <span v-if="item.niveau"> - {{ __(item.niveau.constante) }}</span>
                                </p>
                                <div v-for="(programme, key) in item.programmes">
                                    <p class="ml-2 text-gray-700" v-if="!key">
                                        <template v-if="programme.produit.par_semaines">
                                            <span v-html="__('programmation_semaine', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                        </template>
                                        <template v-else-if="!programme.date_fin">
                                            <span v-html="__('programmation_date', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                        </template>
                                        <template v-else>
                                            <span v-html="__('programmation_periode', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}, {key: 'FIN_JOUR', value: (new Date(programme.date_fin)).getDate()}, {key: 'FIN_MOIS', value: (new Date(programme.date_fin)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'FIN_ANNEE', value: (new Date(programme.date_fin)).getFullYear()}])"></span>
                                        </template>
                                        <template v-if="programme.produit.par_semaines">
                                            - {{ __('Duree_de_formation') }} : {{ item.quantite }}
                                            <span v-if="programme.produit.type_quantite === 'semaine'">{{ __('semaines') }}</span>
                                            <span v-else>{{ __('lecons') }}</span>
                                        </template>
                                    </p>
                                    <!-- <p class="my-1" v-if="!key" v-html="__('modules_choisis')"></p> -->
                                    <p class="text-sm" v-if="!key || (item.programmes[key-1].produit.slug !== programme.produit.slug)"><span v-html="__(programme.produit.slug)"></span></p>
                                </div>
                            </template>
                            <template v-else>
                                <div v-for="(programme, key) in item.programmes">
                                    <p class="font-bold text-cavilam-primary" v-if="!key || (item.programmes[key-1].produit.slug !== programme.produit.slug)">
                                        <span v-html="__(item.produit.categorie.slug) + ' <i class=\'fa fa-chevron-right\'></i> ' + __(programme.produit.slug)"></span>
                                        <span v-if="item.niveau"> - {{ __(item.niveau.constante) }}</span>
                                    </p>
                                    <p class="ml-2 text-gray-700">
                                        <template v-if="programme.produit.par_semaines">
                                            <span v-html="__('programmation_semaine', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                        </template>
                                        <template v-else-if="!programme.date_fin">
                                            <span v-html="__('programmation_date', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}])"></span>
                                        </template>
                                        <template v-else>
                                            <span v-html="__('programmation_periode', [{key: 'DEBUT_MOIS', value: (new Date(programme.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(programme.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(programme.date_debut)).getFullYear()}, {key: 'FIN_JOUR', value: (new Date(programme.date_fin)).getDate()}, {key: 'FIN_MOIS', value: (new Date(programme.date_fin)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'FIN_ANNEE', value: (new Date(programme.date_fin)).getFullYear()}])"></span>
                                        </template>
                                        <template v-if="programme.produit.par_semaines">
                                            - {{ __('Duree_de_formation') }} : {{ item.quantite }}
                                            <span v-if="programme.produit.type_quantite === 'semaine'">{{ __('semaines') }}</span>
                                            <span v-else>{{ __('lecons') }}</span>
                                        </template>
                                    </p>
                                </div>
                            </template>
                            <div v-for="detail in item.produit.details"
                                 class="ml-4 flex text-sm text-gray-600">
                                <p class="w-5/6 italic" v-html="__(detail.detail)"></p>
                                <p class="w-1/6 text-center italic">{{ detail.prix }} €</p>
                            </div>
                        </div>
                        <div class="w-3/6 m-2">
                            <template v-for="option in item.options">
                                <template v-if="option.parent">
                                    <p>
                                        <span v-if="option.parent.name" class="font-bold" v-html="__(option.parent.name)"></span>
                                        <br />
                                        <span v-if="option.name" v-html="'- ' + __(option.name)"></span>
                                    </p>
                                </template>
                                <template v-else-if="option.pivot.value">
                                    <p>
                                        <span v-if="option.name" class="font-bold" v-html="__(option.name)"></span>
                                        <br />
                                        <div  v-if="Array.isArray(option.pivot.value)">
                                            <span v-for="(competence, index) in option.pivot.value" :key="index" v-html="__(competence.name) + ', '"></span>
                                        </div>
                                        <span v-else-if="option.pivot.value" v-html="'- ' + __(option.pivot.value)"></span>
                                    </p>
                                </template>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <p class="text-right text-xs text-gray-400" v-html="__('commande_mentions')"></p>
    </div>
</template>

<script>
import App from '@/Layouts/App'

export default {
    layout: App,
    name: "Commande",
    props: {
        commande: Object,
    },
    methods: {
        reformatDate: function(date) {
            if (date) {
                const dateArr = date.split("-");

                return dateArr[2] + '/' + dateArr[1] + '/' + dateArr[0];
            }

            return '';
        },
        reformatDateTime: function(date) {
            if (date) {
                return new Date(date).toLocaleString();
            }

            return '';
        },
        formatMotifInscription(value) {
            if (!value) {
                return '';
            }

            const aliases = {
                renouvellement_carte_de_resident: 'carte_de_sejour_de_10_ans',
                renouvellement_permis_de_residence: 'carte_de_sejour_pluriannuelle',
            };
            const translationKey = aliases[value] ?? value;
            const translated = this.__(translationKey);

            if (translated === translationKey && translationKey !== value) {
                return this.__(value);
            }

            return translated;
        },
        translateOption(option) {
            return this.__(`${option.option.name}`) + ' : ' + this.__(`${option.value}`);
        },
    }
}
</script>

<style scoped>
    @media print {
        html, body {
            margin: 0;
        }
        @page {
            size: auto !important;
            margin: 0;
        }
        .shadow-md {
            box-shadow: none;
        }
    }
</style>
